module.exports = __webpack_public_path__ + "img/3A3329_C9B090_928069_A9957A-256px.5b611365.png";